import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { dataExportFileName, saveJsonFile, type DataExportSubject } from '@/lib/dataExport';

/**
 * Downloads everything the app holds about a participant or a guardian, for a
 * subject access request (RGPD). The API records who exported whom.
 */
export function useDataExport() {
  return useMutation({
    mutationFn: async ({ subject, id }: { subject: DataExportSubject; id: number }) => {
      const path = subject === 'participant' ? 'participants' : 'guardians';
      const data = await api.get<unknown>(`/api/${path}/${id}/export`);
      saveJsonFile(dataExportFileName(subject, id, new Date()), data);
    },
  });
}
